import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DefaultLayoutPage } from '@ori-appshell/layouts';
import { LoggerProvider } from '@ori/logger';
import { LayoutContentLoader } from '../../components';
import { mainLogger } from '../../logger';
export const Layout = (param)=>{
    let { layoutPage, useOpenedMinibagOnDesktop = false, children } = param;
    return /*#__PURE__*/ _jsx(DefaultLayoutPage, {
        ...layoutPage,
        children: /*#__PURE__*/ _jsx(LoggerProvider, {
            logger: mainLogger,
            children: /*#__PURE__*/ _jsx(LayoutContentLoader, {
                useOpenedMinibagOnDesktop: useOpenedMinibagOnDesktop,
                children: children
            })
        })
    });
};
